import { enableProdMode, importProvidersFrom } from '@angular/core';

import { HttpLoaderFactory } from './app/app.module';
import { environment } from './environments/environment';
import { TRANSLATION_PROVIDERS, TranslateService } from '@shared/services/translate';
import { IntercomService, IntercomConfig, IntercomModule } from '@modules/intercom';
import { providePrimeNG } from 'primeng/config';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { PlatformModule } from '@angular/cdk/platform';
import { OverlayModule } from '@angular/cdk/overlay';
import { CoreModule } from '@shared/core/core.module';
import { ShopboxCommonModule } from '@shared/common/common.module';
import { AppRoutingModule } from './app/app-routing.module';
import { LoginModule } from '@modules/login/login.module';
import { DashboardModule } from '@modules/dashboard';
import { NavModule } from '@modules/side-bar/nav.module';
import { DrawerModule } from 'primeng/drawer';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ProfileModule } from '@modules/profile/profile.module';
import { BreadCrumbsNavigationModule } from '@modules/bread-crumbs-navigation/bread-crumbs-navigation.module';
import { StaffProfileModule } from '@modules/staff-profile/staff-profile.module';
import { WebcamModule } from 'ngx-webcam';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app/app.component';
import MySBtheme from './theme/sb-theme';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmationService } from 'primeng/api';

if (environment.production) {
  enableProdMode();
}

// OAuth callback: providers with a fragment in redirect_uri (hash routing) append
// ?code=&state= to the base URL, BEFORE the hash. Angular's hash router wipes that
// base query on initial navigation, so stash it now — before bootstrap — for the
// OauthCallbackComponent to read.
if (window.location.hash.includes('integrations/callback') && window.location.search) {
  sessionStorage.setItem('oauth-callback-search', window.location.search);
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, PlatformModule, OverlayModule, CoreModule, ShopboxCommonModule, AppRoutingModule, LoginModule, DashboardModule, IntercomModule, NavModule, DrawerModule, ProgressSpinnerModule, ProfileModule, BreadCrumbsNavigationModule, StaffProfileModule, WebcamModule, TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
        // ServiceWorkerModule.register('/ngsw-worker.js', { enabled: false })
        ),
        TRANSLATION_PROVIDERS,
        TranslateService,
        // LogUpdateService,
        IntercomService,
        IntercomConfig,
        providePrimeNG({
            theme: {
                preset: MySBtheme,
                options: {
                    darkModeSelector: false
                }
            }
        }),
        provideAnimationsAsync(),
        provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
        provideFirestore(() => getFirestore()),
        DialogService,
        ConfirmationService
    ]
})
  .catch(err => console.error(err));
